import { styled } from "styled-components";

export const MessageContainer = styled.div(({ theme }) => {
  return {
    padding: "11px 16px 10px 16px",
    maxWidth: 256,
    color: "#1A1E23",
    boxShadow: theme.shadows.surfaceZ1Light,
    borderRadius: theme.radii[2],
    background: theme.colors.white,
    fontSize: 14,

    "&:hover": {
      cursor: "pointer",
    },
  };
});
